import { formatWhatsAppPhone } from "./formatWhatsAppPhone";

/**
 * @param {string|number} serializedId
 * @param {{ lid?: string }} [options]
 */
const formatSerializedId = (serializedId, options) =>
  formatWhatsAppPhone(serializedId, options);

export default formatSerializedId;
